import { ProgramWeekEnum } from 'src/modules/programs/models/programs';

import { CPProgramStepProps } from '../../models/cpProgram';
import { CorePillarsCheckInStep } from './../stepComponents/CorePillarsCheckInStep';
import { CPProgramSharedStep } from './weekShared';

export const cpProgramSharedStepsProps: CPProgramStepProps[] = [
    {
        id: CPProgramSharedStep.CorePillarsCheckInStep,
        component: CorePillarsCheckInStep,
        tooltip: 'Core Pillars Check-In',
        noButtons: true,
    },
];

export const initialCorePillarsRatingData = {
    [ProgramWeekEnum.WeekOne]: 1,
    [ProgramWeekEnum.WeekTwo]: 1,
    [ProgramWeekEnum.WeekThree]: 1,
    [ProgramWeekEnum.WeekFour]: 1,
    [ProgramWeekEnum.WeekFive]: 1,
    [ProgramWeekEnum.WeekSix]: 1,
    [ProgramWeekEnum.WeekSeven]: 1,
    [ProgramWeekEnum.WeekEight]: 1,
};
